import fixture from './fixture';
import steps from './steps';

const FILE_NAME = 'embroidery_emblem.png';

/**
 * Car Emblem — the lesson on cutting a fused shape apart.
 *
 * Bundles everything tied to this one piece of artwork: the card shown in the
 * picker, the pinned palette and stitch settings the editor should start from,
 * and the walkthrough itself.
 */
const emblemTutorial = {
  id: 'emblem',
  design: {
    id: 'emblem',
    name: 'Car Emblem',
    level: 'Advanced',
    // See `docs/tutorial-timing.md` for how this is arrived at.
    minutes: 8,
    blurb: 'A ring and two crossed ovals, traced as one shape. Cut them apart, then satin every piece.',
    image: `/assets/${FILE_NAME}`,
    fileName: FILE_NAME,
    // The design people asked about after the reel of it went round.
    instagram: 'https://www.instagram.com/embroiderytrace/',
    ready: true,
  },
  fixture,
  steps,
};

export default emblemTutorial;
